import { Component, Input } from '@angular/core';

@Component({
    selector: 'xm-bill-preview-expanded-data-panel',
    styleUrls: ['./bill-preview-data-panel-expanded.scss'],
    templateUrl: './bill-preview-data-panel-expanded.html',
    standalone: false
})
export class XmBillPreviewExpandedDataPanelComponent {
    @Input() public byTheGigPlanGroup: LevelMoveDataPlanGroup;
    @Input() public unlimitedPlanGroup: LevelMoveDataPlanGroup;
    @Input() public tabletPlanGroup: LevelMoveDataPlanGroup;
    @Input() public smartWatchPlanGroup: LevelMoveDataPlanGroup;

    public unlimitedPriceLabel: string;
}
